import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/content_arrows/down-large-arrow.svg")